import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ReactNode } from 'react';

import { Tooltip } from 'atoms/tooltip/Tooltip';
import { useIntlContext } from 'contexts/intl';
import { isType } from 'lib/gql';
import { getInGameCurrencyDescription } from 'lib/inGameCurrencyDescription';

import type { RewardTooltip_AnyRewardInterface } from './__generated__/index.graphql';

type Props = {
  children: ReactNode;
  reward: RewardTooltip_AnyRewardInterface;
};

export const RewardTooltip = ({ children, reward }: Props): ReactNode => {
  const { formatMessage } = useIntlContext();
  if (isType(reward, 'InGameCurrencyReward')) {
    const description = getInGameCurrencyDescription(reward, formatMessage);
    if (description) {
      return <Tooltip title={description}>{children}</Tooltip>;
    }
  }
  return children;
};

RewardTooltip.fragments = {
  AnyRewardInterface: gql`
    fragment RewardTooltip_AnyRewardInterface on AnyRewardInterface {
      id
      ...getInGameCurrencyDescription_InGameCurrencyReward
    }
    ${getInGameCurrencyDescription.fragments.inGameCurrencyReward}
  ` as TypedDocumentNode<RewardTooltip_AnyRewardInterface>,
};
